// resetMessage.js
// 防止重复点击重复弹出message消息提示

import { Message } from 'element-ui'
const resetMessage = function (options) {
  const messageDom = document.getElementsByClassName('el-message')[0]
  if (messageDom === undefined) {
    Message(options)
  }
}
const arr = ['success', 'warning', 'info', 'error']
arr.forEach(type => {
  resetMessage[type] = options => {
    const messageDom = document.getElementsByClassName('el-message')[0]
    if (messageDom === undefined) {
      Message[type](options)
    }
  }
})

export const message = resetMessage



// WEBPACK FOOTER //
// ./src/assets/js/message.js